<template>
  <div class="tender-members_left">
    <div class="mt-3 flex flex-between">
      <div>
        <slot name="title"/>
        <div
          v-if="loading"
          class="mt-2 text-left pl-3">
          {{ $tc('Tenders.CreateStep.Members.DescriptionCount', participantsCount) }}
        </div>
      </div>
      <div
        class="ml-auto flex"
        style="max-width: fit-content;">
        <Youcontrol
          class="mr-2"
          @result="inviteMembers"/>
        <InviteNewParticipation
          ref="inviteNewParticipation"
          :disabled="add_invited"
          :invited="invitedParticipants"
          :set-invited="inviteNewParticipation"/>
      </div>
    </div>

    <div
      class="mode-btns">
      <div
        class="mode-btns_item"
        :class="{'active': !isAccreditedTab}"
        @click="changeTab('subscribers')">
        {{ tender.additionalCategories && tender.additionalCategories.length
          ? $t('Tenders.SubscribedToCategories') : $t('Tenders.SubscribedToCategory') }}
        <sChip
          background="var(--green_chosen_light)"
          class="ml-2"
          color="var(--black-color)">
          {{ subscribersUsers.length }}
        </sChip>
      </div>
      <div
        v-if="$can('access', 'AccreditedSuppliers')"
        class="mode-btns_item"
        :class="{'active': isAccreditedTab}"
        @click="changeTab('accredited')">
        {{ $t('Tenders.MySuppliers') }}
        <sChip
          background="var(--green_chosen_light)"
          class="ml-2"
          color="var(--black-color)">
          {{ accreditedSuppliersUsers.length }}
        </sChip>
      </div>
    </div>

    <div class="py-2 flex">
      <sInput
        class-name="serach_field"
        clearable
        debounce
        :disabled="loading_subscribers"
        :placeholder="$t('Tenders.EnterVendorName')"
        prefix-icon="search"
        :value.sync="search"
        @change="createTableData"/>
      <sSelect
        v-if="$can('show', 'tenderResidentFilter')"
        class="ml-2"
        data-qa="type-bidders"
        :disabled="loading_subscribers"
        placeholder="Всі"
        style="max-width: 200px;"
        :value.sync="tender.inviteFilter"
        @update:value="createTableData">
        <sOption
          v-for="(filter, key) in typeResidentFilters"
          :key="key"
          :label="filter.label"
          :value="filter.key"/>
      </sSelect>
    </div>
    <div>
      <v-skeleton-loader
        v-if="loading_subscribers && !isAccreditedTab"
        :boilerplate="false"
        class="mt-4"
        :tile="false"
        type="table-thead, table-tbody"
        width="100%"/>
      <MembersTable
        v-else
        :accred_headers="headers.accred"
        :grouped="tableProps.items"
        inf_selector="#content-container"
        :item_key="!isAccreditedTab ? 'organizationId' : 'groupId'"
        :items="tableProps.items"
        :orgs_headers="isAccreditedTab ? headers.orgAccredited : headers.orgSubscribed"
        :three_levels.sync="isAccreditedTab"
        :users_headers="isAccreditedTab ? headers.usersAccredited : headers.usersSubscribed"
        @expandRow="expandRow">
        <template #header_table_select>
          <sCheckbox
            data-qa="data-0"
            :disabled="add_invited || (!isAccreditedTab && isPublic)"
            :indeterminate="tableProps.checkMode === 'indeterminated'"
            :value="tableProps.checkMode === 'all'"
            @input="selectAll"/>
        </template>
        <template #item_table_select=" { item }">
          <sCheckbox
            v-if="!isAccreditedTab && isPublic"
            :key="`group${item.organizationId}`"
            data-qa="data-1"
            disabled
            :indeterminate="tableProps.checkMode === 'indeterminated'"
            :value="true"/>
          <sCheckbox
            v-else
            :key="`mygroup${item.organizationId}`"
            data-qa="data-2"
            :disabled="add_invited || !item.organisations || !item.organisations.length"
            :indeterminate="item.indeterminated"
            :value="item.selected"
            @input="changeState(item)"/>
        </template>
        <template #expand_item_select="{ item, count }">
          <sCheckbox
            v-if="!isAccreditedTab && isPublic"
            :key="`group${item.organizationId}`"
            data-qa="data-3"
            :disabled="true"/>
          <sCheckbox
            v-else
            :key="`item${item.organizationId}${count}`"
            data-qa="data-4"
            :disabled="add_invited"
            :indeterminate="item.indeterminated"
            :value="item.selected"
            @input="changeState(item)"/>
        </template>
      </MembersTable>
    </div>
  </div>
</template>
<script>
//import CartList from 'components/common/blocks/CartList.vue'
import MembersTable from 'components/tenders/MembersTable.vue'
import Youcontrol from  'components/tenders/dialogs/Youcontrol.vue'
import InviteNewParticipation from 'components/tenders/dialogs/InviteNewParticipation.vue'

import editTenderMixin from 'mixins/editTenderMixin.js'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  name: 'TenderMembers',
  mixins: [editTenderMixin],
  data() {
    return {
      computedSubscribedToCategory: [],

      loading: false,
      loading_subscribers: false,
      currentInviteFilter: null,

      typeResidentFilters: {
        ALL: {
          label: this.$t('Tenders.ResidentType.ALL'),
          key: 'ALL'
        },
        RESIDENT: {
          label: this.$t('Tenders.ResidentType.RESIDENT'),
          key: 'RESIDENT'
        },
        NOT_RESIDENT: {
          label: this.$t('Tenders.ResidentType.NOT_RESIDENT'),
          key: 'NOT_RESIDENT'
        }
      },

      tableProps: {
        mode: 'subscribers', // subscribers || accredited
        items: [],
        key: '',
        checkMode: 'empty' // empty || indeterminated || all
      },

      search: '',

      headers: {
        orgSubscribed: [
          {text: '', value: 'data-table-select', width: '40px', filterable: false },
          {text: this.$t('Tenders.Company'), value: 'organizationTitle', filterable: false },
          {text: this.$t('Tenders.EDRPOU'), value: 'organizationUsreou', sortable: false, width: '138px', filterable: false  },
          {text: this.$t('Tenders.Rating'), value: 'supplierRatings', width: '115px', filterable: false },
          {text: '', value: 'count', sortable: false, width: '38px', filterable: false },
        ],
        usersSubscribed: [
          {text: '', value: 'data-table-select', width: '50px', filterable: false },
          {text: '', value: 'userConcatNameEmail' },
          {text: '', value: 'empty', sortable: false, width: '20px', filterable: false },
        ],
        accred: [
          {text: '', value: 'data-table-select', width: '40px' },
          {text: this.$t('Planning.Name'), value: 'groupName' },
          {text: this.$t('Tenders.Note'), value: '2', width: '150px', filterable: false },
          {text: this.$t('Tenders.EDRPOU'), value: '', sortable: false, width: '135px', filterable: false  },
          {text: this.$t('Tenders.Rating'), value: '', width: '115px', filterable: false },
          {text: '', value: 'count', sortable: false, width: '20px' },
        ],
        orgAccredited: [
          {text: '', value: 'data-table-select', width: '50px', filterable: false },
          {text: this.$t('Tenders.Company'), value: 'organizationTitle', filterable: false },
          {text: this.$t('Tenders.Note'), value: '1', width: '150px', filterable: false },
          {text: this.$t('Tenders.EDRPOU'), value: 'organizationUsreou', sortable: false, width: '135px', filterable: false  },
          {text: this.$t('Tenders.Rating'), value: 'supplierRatings', width: '115px', filterable: false },
          {text: '', value: 'count', sortable: false, width: '20px', filterable: false },
        ],
        usersAccredited: [
          {text: '', value: 'data-table-select', width: '60px', filterable: false },
          {text: '', value: 'userConcatNameEmail', },
          {text: this.$t('Tenders.Note'), value: 'remark', width: '400x', filterable: false },
          {text: '', value: 'empty', sortable: false, width: '20px', filterable: false },
        ],

      }
    }
  },
  methods: {
    customCheckChange() {
      return this.currentInviteFilter !== this.tender.inviteFilter
    },
    async beforeSendTender() {
      const result = this.$_.cloneDeep(this.tender)
      delete result.members
      this.$emit('update:tender', result)
    },
    async changeState(item) {
      let users
      if (this.tableProps.mode === 'subscribers') {
        if (!item.selected && !item.email) {
          this.$notice.warning({
            title: this.$t('Common.ErrorTitle'),
            message: 'Ви не можете додати цього користувача через відсутність пошти',
            duration: 10
          })

          item.selected = false
          return
        }
        item.userName = item.name
        delete item.name
        users = [item]
      } else if (this.tableProps.mode === 'accredited') {
        if (item.users?.length || item.organisations) {
          users = item.users || item.organisations?.reduce((tot, el) => {
            tot.push(...el.users || [])
            return tot
          }, []) || []
        } else {
          users = [item]
        }
      }

      let invited = this.$_.cloneDeep(this.invitedParticipants)

      if (!item.selected) {
        users.forEach(user => {
          if (user.email && !invited.some(inv => inv.email === user.email)) {
            invited.push(user)
          }
        })
      } else {
        invited = invited.filter(inv => inv.email && !users.some(user => user.email === inv.email))
      }
      /*if (!invited?.length) {
        this.$notice.warning({
          title: this.$t('Common.ErrorTitle'),
          message: 'Перелік для запрошеня пустий',
          duration: 10
        })
        return
      }*/
      await this.mixin_setInvited(invited)
      await this.createSelectTableData()
    },
    changeTab(state) {
      if (this.tableProps.mode !== state) {
        this.tableProps.mode = state
        this.createTableData()
      }
    },
    /**
     * Применяем фильтры для эллемента
     */
    filterMembersBySearch(item) {
      const search = this.search?.toLowerCase()
      const residentFilter = this.tender.inviteFilter ?? this.typeResidentFilters.ALL.key

      if (item.organisations) {
        item.filtred_orgs = item.organisations.filter(this.filterMembersBySearch)
      } else {
        let filteredUsers = item.users || []

        // Фильтрация по поиску
        if (search) {
          filteredUsers = filteredUsers.filter(u =>
            u.userName?.toLowerCase().includes(search) ||
            u.email?.toLowerCase().includes(search) ||
            u.name?.toLowerCase().includes(search)
          )
        }

        // Фильтрация по резидентности
        if (residentFilter && residentFilter !== this.typeResidentFilters.ALL.key) {
          filteredUsers = filteredUsers.filter(u => {
            if (residentFilter === this.typeResidentFilters.RESIDENT.key) { // Резиденты
              return u.isResident === true
            } else if (residentFilter === this.typeResidentFilters.NOT_RESIDENT.key) { // Нерезиденти
              return u.isResident === false
            }
            return true
          })
        }

        item.filtred_users = filteredUsers.length > 0 ? filteredUsers : null
      }

      // Если нет поиска и фильтра резидентности, показываем все
      if (!search && residentFilter === this.typeResidentFilters.ALL.key) {
        item.filtred_users = null
        //item.expanded = item.expanded ?? false
        return true
      }

      const hasMatch = (search && (
        item.organizationTitle?.toLowerCase().includes(search) ||
        item.organizationUsreou?.toString().includes(search) ||
        item.groupName?.toString().includes(search)
      )) || (item.filtred_users && item.filtred_users.length) ||
                   (item.filtred_orgs && item.filtred_orgs.length)

      //item.expanded = hasMatch
      return hasMatch
    },
    expandRow(item) {
      item.expanded = !item.expanded
    },
    async selectAll() {
      if (this.tableProps.checkMode === 'all') {
        await this.mixin_setInvited([])
      } else {
        await this.inviteNewParticipation(this.formatUsers)
      }
    },
    /**
     * YC.Market
     */
    inviteMembers(emails) {
      if (!emails?.length) {
        return
      }
      const invited = this.invitedParticipants.map(i => i.email)

      const parseEmails = emails
        .map(i => ({
          email: i,
          manualAdded: true,
          organizationId: 0,
          organizationTitle: '',
          organizationUsreou: '',
          selected: true,
          uniqId: (Math.random() + 1).toString(36).substring(7),
        })
        )

      const newEmails = this.mixin_checkRuEmailDomen(parseEmails)
        .filter(i => !i.blockDomen && !invited.some(ie => ie  === i.email))

      this.mixin_setInvited([ ...this.invitedParticipants, ...newEmails ])
    },
    /**
     * Приглашение вручну
     */
    async inviteNewParticipation(item) {
      let newInvited = [...item || [], ...this.invitedParticipants || []]
      newInvited = this.mixin_getUnicByEmail(newInvited)
      return new Promise(async (resolve) => {
        resolve(await this.mixin_setInvited(newInvited))
      })
    },
    async createTableData() {
      this.tableProps.items = this.isAccreditedTab
        ? this.accreditedSuppliers.filter(this.filterMembersBySearch)
        : this.subscribedToCategory.filter(this.filterMembersBySearch)

      await this.createSelectTableData()
    },
    async createSelectTableData() {
      const emails = this.invitedParticipants.map(i => i.email.toLowerCase())
      const setSelectAccredited = (items) => {
        items.forEach(item => {
          let countOrganisationIndeterminated = 0
          let countOrganisationSelect = 0
          let countOrganisations = 0
          item?.organisations?.forEach(org => {
            countOrganisations++
            let countUsersSelect = 0
            let countUsers = 0
            if (org.users) {
              org.users.forEach(user => {
                countUsers++
                if (emails.includes(user.email.toLowerCase())) {
                  user.selected = true
                  countUsersSelect++
                } else {
                  user.selected = false
                }
              })
            }
            if (!org.users?.length || !!countUsersSelect && countUsersSelect === countUsers) {
              org.selected = true
              countOrganisationSelect++
            } else {
              org.selected = false
            }
            org.indeterminated = !org.selected && !!countUsersSelect && countUsersSelect !== countUsers ? true : false

            if (org.indeterminated) {
              countOrganisationIndeterminated++
            }
          })

          item.selected = !countOrganisations || !!countOrganisations && countOrganisationSelect === countOrganisations || false
          item.indeterminated = countOrganisationIndeterminated
            ? true
            : (item.selected ? false : (countOrganisationSelect && countOrganisationSelect !== countOrganisations ? true : false))
        })

        items.selected = !items?.organisations?.find(i => !i.selected) || false
        items.indeterminated = items.selected ? false : (items?.organisations?.find(i => i.selected) ? true : false)

        return items
      }
      const setSelectSubscribed = (items) => {
        items?.forEach((item) => {
          let countUsersSelect = 0
          let countUsers = 0
          item.users?.forEach((user) => {
            countUsers++
            if (this.isPublic || emails.includes(user.email.toLowerCase())) {
              user.selected = true
              countUsersSelect++
            } else {
              user.selected = false
            }
          })
          item.selected = !!countUsers && countUsersSelect === countUsers || false
          item.indeterminated = item.selected ? false : (countUsersSelect && countUsersSelect !== countUsers ? true : false)
        })
        return items
      }

      const functionSelect = this.isAccreditedTab ? setSelectAccredited : setSelectSubscribed
      this.tableProps.items = functionSelect(this.tableProps.items)

      function checkSelections(arr) {
        const allSelected = arr.every(item => item.selected === true)
        const anySelected = arr.some(item => item.selected === true)

        if (allSelected) {
          return 'all'
        } else if (anySelected) {
          return 'indeterminated'
        } else {
          return 'empty'
        }
      }

      if (!this.isAccreditedTab && this.isPublic) {
        this.tableProps.checkMode = 'all'
      } else {
        this.tableProps.checkMode = checkSelections(this.tableProps.items)
      }
      //})
    }
  },
  computed: {
    formatUsers() {
      let result = []
      if (this.isAccreditedTab) {
        const emails = this.tableProps.items
          .map((item) => {
            return item.organisations?.reduce((tot, el) => {
              tot.push(...el.users || [])
              return tot
            }, [])
          }).flat(1)

        let uniqIds = {}

        let uniqueEmails = emails.filter(email => {
          if (!uniqIds[email.uniqId]) {
            uniqIds[email.uniqId] = true
            return true
          }
          return false
        })

        return uniqueEmails
      } else {
        result = this.tableProps.items.map(i => i.users) || []
      }

      return result.flat(1)
    },
    isAccreditedTab() {
      return this.tableProps.mode === 'accredited'
    },
    isPublic() {
      return this?.tender?.biddingType?.isPublic
    },
    //TODO: переписать. Метод в computed
    subscribersUsers() {
      return this.mixin_getUsers(this.subscribedToCategory)
    },
    //TODO: переписать. Метод в computed
    accreditedSuppliersUsers() {
      let orgs = this.accreditedSuppliers.reduce((total, group) =>  total.concat(group.organisations) , [])
      return this.mixin_getUsers(orgs)
    },
  },
  components: {
    Youcontrol,
    MembersTable,
    InviteNewParticipation
  },
  watch: {
    loading_subscribers() {
      this.createTableData()
    }
  },
  async mounted() {
    this.loading = true
    this.loading_subscribers = true

    if (this.$can('access', 'AccreditedSuppliers')) {
      await api.accreditedSuppliers(this.tender.tenderId)
        .then(async res => {
          this.accreditedSuppliers = res
            .map((group => {
              const result = {
                id: group.groupId,
                groupName: group.groupName,
                groupId: group.groupId,
                expanded: false,
                organisations: [],
                selected: false,
                indeterminated: true
              }
              this.$_.cloneDeep(group?.organisations || [])
                .forEach(org => {
                  const orgResult = {
                    organizationId: org.organizationId,
                    organizationUsreou: org.usreou,
                    organizationTitle: org.organizationTitle,
                    supplierRatings: org.rating,
                    groupId: group.groupId,
                    groupName: group.groupName,
                    expanded: false,
                    participationCount: null,
                    users: [],
                    selected: false,
                    indeterminated: false
                  }
                  let uniqId = ''
                  org?.users.forEach((user) => {
                    uniqId = /*user.emailId + '_' + */user.email.toLowerCase() + '_' + user.name

                    orgResult.users.push({
                      organizationTitle: orgResult.organizationTitle,
                      organizationUsreou: orgResult.organizationUsreou,
                      organizationId: orgResult.organizationId,
                      email: user.email?.replace('\r', '')?.replace('\n', '')?.trim().toLowerCase(),
                      userName: user.name,
                      supplierRatings: orgResult.supplierRatings,
                      manualAdded: true,
                      remark: user.remark,
                      not_registered: false,
                      uniqId
                    })
                  })
                  result.organisations.push(orgResult)
                })
              return result
            }))
        })
    }
    if (this.tender?.classificationCode) {
      await this.mixin_getParticipantsCount(this.tender.classificationCode)
    }

    this.subscribedToCategory = await this.$store.dispatch('subscribedUsers', { tenderId: this.tender.tenderId })
    
    this.currentInviteFilter = this.tender.inviteFilter ? '' + this.tender.inviteFilter : 'ALL'

    await this.mixin_getInvitedParticipants()

    this.$root.$on('changeInvitedList', this.createTableData)
    this.loading_subscribers = false
  },
  beforeDestroy() {
    this.beforeSendTender()
    this.$root.$off('changeInvitedList', this.createTableData)
  },
  props: {
    tender: {
      type: Object
    },
    rules: {
      type: Object
    }
  },
}
</script>
<style scoped lang="scss">
.mode-btns {
  display: flex;
  padding-top: 20px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  text-transform: uppercase;
  gap: 14px;
  &_item {
    cursor: pointer;
    white-space: nowrap;
    height: 30px;
    transition: 0.25s all;
    padding: 6px 3px;
    border-radius: 5px;
    &.active {
      border-radius: 5px 5px 0 0;
      border-bottom: 2px solid var(--black-color);
    }
    &:focus,
    &:hover {
      opacity: 0.6;
    }
  }
}
</style>
